import React from "react";
import { connect } from "react-redux";

import { closeDatesModal } from "@/components/datePicker/DatePicker.state";

const Overlay = ({ closeDatesModal }) => (
  <div onClick={closeDatesModal} className="overlay" />
);

export const mapDispatchToProps = {
  closeDatesModal,
};

export default connect(null, mapDispatchToProps)(Overlay);
